export const reviewAndSubmitQuestions: Record<string, any> = {
  termsConfirmed: {
    labelKey: 'applicationForm.REVIEW_AND_SUBMIT.termsConfirmed',
  },
  privacyAccepted: {
    labelKey: 'applicationForm.REVIEW_AND_SUBMIT.privacyAccepted',
  },
};
